var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedcorderOutlineB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.452 10C22.7123 10 21.2055 11.5786 19.726 13.4838C18.6027 11.3609 16.7671 10.0272 14.5753 10.0272C10.5753 10.0272 8 14.1371 8 17.3215C8 23.7721 13.6986 27.256 19.8082 27.256V30.0938C19.8082 30.695 20.449 31.0856 20.9866 30.8096C26.1804 28.1438 31.9746 22.4113 32 17.4304C32 12.8578 29.0959 10 25.452 10",
    stroke: "#7674E2",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6597 18.0583H26.6233V19.0857C26.6233 19.6531 26.1592 20.113 25.5869 20.113C25.0144 20.113 24.5504 19.6531 24.5504 19.0857V18.0583H23.514C22.9416 18.0583 22.4775 17.5983 22.4775 17.031C22.4775 16.4636 22.9416 16.0036 23.514 16.0036H24.5504V14.9763C24.5504 14.4089 25.0144 13.949 25.5869 13.949C26.1592 13.949 26.6233 14.4089 26.6233 14.9763V16.0036H27.6597C28.2321 16.0036 28.6962 16.4636 28.6962 17.031C28.6962 17.5983 28.2321 18.0583 27.6597 18.0583Z",
    fill: "#7674E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedcorderOutlineB);
export default __webpack_public_path__ + "static/media/medcorder_outline_b.481a1d37460af2dc243f67934699d967.svg";
export { ForwardRef as ReactComponent };